import { useMutation } from "@apollo/client";
import { useState } from "react";
import styled from "styled-components";

import { FormContainer } from "../../../components/base";
import { USER_CREATE } from "../../../graphql";

export const ContentContainer = styled.div`
  display: grid;
  grid-area: main;
  align-self: center;
  grid-template-rows: 0.2fr 1fr 1fr 1fr;
  grid-template-areas: "header" "body" "body" "footer";
  form {
    grid-area: body;
  }
`;

const RegistrationFormContainer = styled(FormContainer)`
  grid-template-rows: repeat(6, 1fr);
  button[type="submit"] {
    max-height: 35px;
    align-self: end;
  }
`;

export const RegistrationForm = () => {
  const [userCreate, { error }] = useMutation(USER_CREATE);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [linkedin, setLinkedIn] = useState("");

  if (error) console.error(error);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        userCreate({
          variables: {
            user: {
              email,
              password,
              firstName,
              lastName,
              linkedin,
            },
          },
        });
      }}
    >
      <RegistrationFormContainer>
        <input
          type="text"
          id="firstName"
          name="firstName"
          placeholder="First name"
          value={firstName}
          onChange={(event) => setFirstName(event.currentTarget.value)}
          required
        ></input>
        <input
          type="text"
          id="lastName"
          name="lastName"
          placeholder="Last name"
          value={lastName}
          onChange={(event) => setLastName(event.currentTarget.value)}
          required
        ></input>
        <input
          type="text"
          id="email"
          name="email"
          placeholder="Email"
          value={email}
          onChange={(event) => setEmail(event.currentTarget.value)}
          required
        ></input>
        <input
          type="password"
          id="password"
          name="password"
          placeholder="Password"
          value={password}
          onChange={(event) => setPassword(event.currentTarget.value)}
          required
        ></input>
        <input
          type="text"
          id="linkedin"
          name="linkedin"
          placeholder="LinkedIn"
          value={linkedin}
          onChange={(event) => setLinkedIn(event.currentTarget.value)}
          required
        ></input>
        <button type="submit">Submit</button>
      </RegistrationFormContainer>
    </form>
  );
};
